<template>
	<div>
		<el-form ref="form" :model="form" :rules="rules" label-width="120px" style="width: 600px;">
			<el-form-item label="角色名称" prop="roleName">
				<el-input v-model="form.roleName" placeholder="请输入角色名称"></el-input>
			</el-form-item>
			<el-form-item label="权限管理">
				<el-tree :check-strictly="true" :data="menus" show-checkbox node-key="id" :props="defaultProps" ref="tree" highlight-current
					@check-change="handleChange" :default-checked-keys="form.menuIds">
				</el-tree>
			</el-form-item>
			<el-form-item>
				<el-button @click="$router.back()">取消</el-button>
				<el-button type="primary" @click="handleSave">保存</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import { add, edit, detail } from "@/api/permission/role";
import { list } from "@/api/permission/menu";
export default {
	data() {
		return {
			id: null,
			form: {
				roleName: "",
				menuIds: []
			},
			menus: [],
			defaultProps: {
				label: "name",
				children: "children",
			},
			rules: {
				roleName: [{ required: true, message: '请输入角色名称' }]
			}
		}
	},
	mounted() {
		this.id = this.$route.query.id;
		if (this.id) {
			this.getDetail();
		}
		this.getMenus();
	},
	methods: {
		getMenus() {
			list().then(({ code, result, message }) => {
				if (code == 200) {
					this.menus = result;
				} else {
					this.$message.error(message);
				}
			})
		},
		handleChange() {
			this.form.menuIds = this.$refs.tree.getCheckedKeys()
		},
		getDetail() {
			detail({ id: this.id }).then(({ code, result, message }) => {
				if (code == 200) {
					this.form = { ...result };
				} else {
					this.$message.error(message);
				}
			})
		},
		handleSave() {
			this.$refs.form.validate(valid => {
				if (!valid) return;
				const params = {
					...this.form
				}
				if (!this.id) {
					add(params).then(({ code, message }) => {
						if (code == 200) {
							this.$message.success("添加成功");
							this.$router.back();
						} else {
							this.$message.error(message);
						}
					})
				} else {
					params.id = this.id;
					edit(params).then(({ code, message }) => {
						if (code == 200) {
							this.$message.success("修改成功");
							this.$router.back();
						} else {
							this.$message.error(message);
						}
					})
				}
			})
		}
	}
}
</script>

<style></style>